<template>
  <el-dialog
    title="物料校验"
    :visible.sync="visible"
    width="600px"
    @close="commitfalseRow"
  >
    <el-form label-width="120px">
      <el-form-item label="工单号">
        <el-input v-model="workOrderNo" disabled="true" />
      </el-form-item>
      <el-form-item label="袋码">
        <el-input v-model="packageNo" disabled="true" />
      </el-form-item>
      <el-form-item label="条码">
        <el-input v-model="barcode" disabled="true" />
      </el-form-item>
      <el-form-item label="配件编码">
        <el-input v-model="partCode" disabled="true" />
      </el-form-item>
      <el-form-item label="一物一码物料">
        <el-input v-model="isOneCodeMaterial" disabled="true" />
      </el-form-item>
      <el-form-item label="旧件一物一码:">
        <el-input
          ref="oldItemBarcodeInput"
          v-model="oldItemBarcode"
          placeholder="请使用扫码枪扫描"
          clearable
          @input="handleInput"
        />
      </el-form-item>
      <el-form-item label="校验结果:">
        <el-tag :type="getResultTagType(checkResult)">
          {{ checkResult || '未校验' }}
        </el-tag>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
<!--      <el-button-->
<!--        type="primary"-->
<!--        :loading="loading"-->
<!--        @click="$emit('query')"-->
<!--      >-->
<!--        查询-->
<!--      </el-button>-->
      <el-button
        type="primary"
        @click="commitfalseRow"
      >
        取消
      </el-button>
<!--      <el-button-->
<!--        type="success"-->
<!--        :disabled="!checkResult"-->
<!--        @click="commitRow"-->
<!--      >-->
<!--        确定-->
<!--      </el-button>-->
    </div>
  </el-dialog>
</template>

<script>
import request from "@/router/axios";
import api from "@/api/projectApi";

export default {
  props: ['param'],
  created(){
    this.workOrderNo= this.param?this.param.workOrderNo?this.param.workOrderNo:'':''
    this.packageNo = this.param?this.param.packageNo?this.param.packageNo:'':''
    this.barcode = this.param?this.param.barcode?this.param.barcode:'':''
    this.partCode = this.param?this.param.partCode?this.param.partCode:'':''
    this.isOneCodeMaterial = this.param?this.param.isOneCodeMaterial?this.param.isOneCodeMaterial:'':''
    this.oldItemBarcode = this.param?this.param.oldItemBarcode?this.param.oldItemBarcode:'':''
    this.checkResult = this.param?this.param.checkResult?this.param.checkResult:'':''

  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.oldItemBarcodeInput.focus();
    });
    document.addEventListener('keyup', this.handleKeyUp);
  },

  beforeDestroy() {
    // 组件销毁时移除监听
    document.removeEventListener('keyup', this.handleKeyUp);
  },

  data() {
    return {
      visible:true,
      drawer: true,
      workOrderNo: '',
      packageNo:'',
      barcode:'',
      partCode:'',
      isOneCodeMaterial:'',
      oldItemBarcode:'',
      checkResult:'',
      supplierName:'',
      lastInputTime: 0,      // 上次输入时间戳
      inputTimer: null,      // 输入间隔计时器
      isScannerInput: false  // 是否扫码枪输入标志
    }
  },
  methods: {
    handleKeyUp(e) {
      if (e.keyCode === 13) {  // 13 是回车键的 keyCode
        this.searchPartsBarcode();
      }
    },
    handleInput(e) {
      const now = Date.now();
      const timeDiff = now - this.lastInputTime;

      // 如果输入间隔小于50ms，认为是扫码枪输入
      if (timeDiff < 50) {
        this.isScannerInput = true;
        clearTimeout(this.inputTimer);
      } else {
        this.isScannerInput = true;
      }

      this.lastInputTime = now;

      // 设置一个计时器，如果300ms内没有新输入，则认为输入结束
      clearTimeout(this.inputTimer);
      this.inputTimer = setTimeout(() => {
        if (this.isScannerInput) {
          console.log('扫码枪输入完成:', this.oldItemBarcode);
          this.searchPartsBarcode()
          // 这里可以触发扫码完成后的处理逻辑
        } else {
          console.log('键盘输入:', this.oldItemBarcode);
          // 如果是键盘输入，可以清空输入或提示
          this.$message.warning('请使用扫码枪扫描，不要手动输入');
          this.oldItemBarcode = '';
        }
        this.isScannerInput = false;
      }, 300);
    },

    handleClose() {
      this.$emit('update:visible', false); // 通过 .sync 关闭

    },
    getResultTagType(result) {
      if (!result) return false;
      if (result) return true;
      return false;
    },
    searchPartsBarcode() {
      if(!this.oldItemBarcode){
        this.$message({message: '请填写配件条码', type: 'warning'});
        return;
      }
      this.$mask.open()
      request({
        url:api.spPartsReturnHeader.searchPartsBarcode,
        method: 'post',
        data: {
          itemBarcode: this.barcode,
          partsBarcode:this.oldItemBarcode
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if(response.data.type == "success"){
          this.$message({ message:response.data.content,type: 'success'});
          if(response.data.data.sameFlag==1){
            this.checkResult = "一致";
            this.supplierName = response.data.data.supplierName
          }else if(response.data.data.sameFlag==2){
            this.checkResult = "不一致"
            this.supplierName = response.data.data.supplierName
          }else if(response.data.data.sameFlag==3){
            this.checkResult = "查无此码"
          }
          this.$mask.close()
          this.commitRow()
        }else{
          this.$message({ message:response.data.content,type: 'warning'});
        }
      }).catch(() => {
        this.$mask.close()
      })
    },

    commitRow() {
      this.$emit('commitSelectedRow', this.packageNo,this.checkResult,this.supplierName,this.oldItemBarcode)
    },

    commitfalseRow() {
      this.$emit('commitSelectedRow', this.packageNo,'旧件无码',null,null)
    },
  }
};
</script>
